<app-dialog-header [title]="'CERTIFICATE.SINGULAR'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24">
    <form [formGroup]="certificateForm">
        <div fxLayout="column">
            <div class="w-100-p mb-24" fxLayout="column" fxLayoutAlign="center flex-start">
                <label class="mb-8 text-lightgreytextcolor text-xs">{{ 'USER.SINGULAR' | translate }}</label>
                <div fxLayout="row" fxLayoutAlign="flex-start center">
                    <div>
                        <img
                            class="avatar"
                            *ngIf="certificateRecord.owner?.avatar.src; else initials"
                            [alt]="certificateRecord.owner.fullName"
                            [src]="certificateRecord.owner.avatar.src"
                        />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ certificateRecord.owner.fullName | initials }}</div>
                        </ng-template>
                        <ng-template [onlineStateIndicator]="certificateRecord.owner.isOnline"> </ng-template>
                    </div>
                    <div>
                        <span>{{ certificateRecord.owner.fullName }}</span>
                    </div>
                </div>
            </div>

            <mat-form-field class="w-100-p">
                <input matInput formControlName="name" placeholder="{{ 'GENERAL.PROPERTY.NAME' | translate }}" />
            </mat-form-field>

            <mat-form-field class="w-100-p">
                <input matInput formControlName="issueDate" placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' | translate }}" />
            </mat-form-field>

            <div class="w-100-p mb-24" fxLayout="column" fxLayoutAlign="center flex-start" *ngIf="module">
                <label class="mb-8 text-lightgreytextcolor text-xs">{{ 'MODULE.SINGULAR' | translate }}</label>

                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="bg-gray-100 py-8 pr-16 pl-8 rounded-full max-w-60 text-truncate"
                    [ngClass]="{ 'hover:bg-gray-200 pointer': !isViewOnly }"
                    (click)="goToModule(module)"
                >
                    <div *ngIf="module.image; else noModuleImage">
                        <img class="avatar pointer" [alt]="module.name" [src]="module.image.thumbUrl" />
                    </div>
                    <ng-template #noModuleImage>
                        <div class="avatar pointer module-icon-container no-image">
                            <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                        </div>
                    </ng-template>
                    <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="module | getModuleIcon"></mat-icon>
                    <span class="text-truncate mr-8 min-w-0 font-medium" [tooltipIfTruncated]="module.name">{{ module.name }}</span>
                    <mat-icon *ngIf="!isViewOnly">keyboard_arrow_right</mat-icon>
                </div>
            </div>
            <div class="p-24 bg-lightgreybackground mt-8 replace-wrapper" fxLayoutAlign="space-between center" *ngIf="!isViewOnly">
                <label class="text-base text-darktextcolor font-medium">{{ 'CERTIFICATE.SINGULAR' | translate }}</label>
                <app-white-button [label]="'GENERAL.BUTTON.DOWNLOAD' | translate" [svgIcon]="'download'" (click)="downloadCertificate(certificateRecord)"></app-white-button>
            </div>
        </div>
    </form>
    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="row" fxLayoutAlign="flex-start space-between" fxLayoutGap="32px">
            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-60 mb-24 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-24 animate"></div>
            </div>

            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div fxLayout="row wrap">
                    <div class="shimmer-card module animate" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(100%-8px)"></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
